import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";

export class OmsShipmentAssignTableRowController implements IController {

  supplier: any;
  onAssign: Function;

  private currency: any;

  /* @ngInject */
  constructor(private splitService: SplitService) {
    this.currency = splitService.getCurrencySymbol();
  }
}

angular
.module('bringoz.admin.oms')
.component('omsShipmentAssignTableRow', {
  bindings: {
    supplier: '<',
    onAssign: '&'
  },
  template: require('./oms-shipment-assign-table-row.html').default,
  controller: OmsShipmentAssignTableRowController
});
